<template>
  <wrld-box :headerTitle="$t('overview')">
    <template v-slot:boxContent>
      <v-container
        class="pa-4"
      >
        <v-row>
          <v-col sm="6">
            <OrderDetailOverviewTimeline :order="order" />
          </v-col>
          <v-divider vertical />
          <v-col>
            <v-row>
              <v-col class="text-right" sm="4">
                <span class="subheading">{{$t('orders.customer_ref')}}</span>
              </v-col>
              <v-col offset-sm="1">
                <span class="subheading">{{order.customer_ref}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-right" sm="4">
                <span class="subheading">{{$t('orders.departure_date')}}</span>
              </v-col>
              <v-col offset-sm="1">
                <span class="subheading">{{order.departure_date | dateToReadableFull($i18n.locale)}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-right" sm="4">
                <span class="subheading">{{$t('orders.delivery_date')}}</span>
              </v-col>
              <v-col offset-sm="1">
                <span class="subheading">{{order.delivery_date | dateToReadableFull($i18n.locale)}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-right" sm="4">
                <span class="subheading">{{$t('orders.total_volume_2')}}</span>
              </v-col>
              <v-col offset-sm="1">
                <span class="subheading">{{getOrderTotalVolume(order) | roundValue(1)}} CBM</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-right" sm="4">
                <span class="subheading">{{$t('orders.total_weight_2')}}</span>
              </v-col>
              <v-col offset-sm="1">
                <span class="subheading">{{getOrderTotalWeight(order) | roundValue(1)}} KG</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-right" sm="4">
                <span class="subheading">{{$t('orders.status')}}</span>
              </v-col>
              <v-col offset-sm="1">
                <span class="subheading">{{ order.status? $t('orders.'+order.status): '' }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-right" sm="4">
                <span class="subheading">{{$t('orders.comment')}}</span>
              </v-col>
              <v-col offset-sm="1">
                <span class="subheading">
                  {{order.comment.trim()}}
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </wrld-box>
</template>

<script>
import OrderDetailOverviewTimeline from '@/components/orders/OrderDetailOverviewTimeline.vue'

export default {
  name: 'OrderDetailOverview',
  components: {
    OrderDetailOverviewTimeline
  },
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  methods: {
    getOrderTotalWeight (order) {
      let res = 0
      let pkg = order.packages
      for (var i = 0; i < pkg.length; i++) {
        res += pkg[i].weight
      }
      return res
    },
    getOrderTotalVolume (order) {
      let res = 0
      let pkg = order.packages
      for (var i = 0; i < pkg.length; i++) {
        res +=
          (pkg[i].dimensions.width *
            pkg[i].dimensions.length *
            pkg[i].dimensions.height) /
          1000000
      }
      return res
    },
    formatComment (comment) {
      return 'foo'
    }
  }
}
</script>
